import {ModuleConfiguration} from "../router/model/UserPermission";
import {SortablePaginationModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const SortablePaginationModuleConfiguration = new ModuleConfiguration(SortablePaginationModuleName, [
    AngularJsMaterialModuleName
]);